export enum EAttachmentUploadStatus {
  IDLE = "idle",
  IN_PROGRESS = "in-progress",
  FINISHED = "finished",
  ERROR = "error",
}
